import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Check, UserPlus } from "lucide-react";
import { api } from "../../lib/api";

export default function ModuleShare({ moduleKey, item, onClose }) {
  const [users, setUsers] = useState([]);
  const [members, setMembers] = useState([]);
  const [sel, setSel] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get(`/mod/${moduleKey}/users`),
      api.get(`/mod/${moduleKey}/items/${item.id}/members`),
    ]).then(([u, m]) => { setUsers(u.data); setMembers(m.data.member_ids || []); })
      .catch(() => {}).finally(() => setLoading(false));
  }, [moduleKey, item.id]);

  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); setSel(n); };

  const save = async () => {
    if (sel.size === 0) return toast.error("Selecciona al menos un usuario");
    setSaving(true);
    try {
      const r = await api.post(`/mod/${moduleKey}/items/${item.id}/members`, { user_ids: [...sel] });
      toast.success(`${r.data.added} colaborador(es) agregado(s)`);
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); } finally { setSaving(false); }
  };

  return (
    <div className="space-y-3" data-testid="module-share">
      <p className="text-sm text-navy/50">Invita a colaboradores de tu empresa. Recibirán una notificación.</p>
      {loading ? <div className="py-6 flex justify-center text-navy/40"><Loader2 className="w-5 h-5 animate-spin" /></div> : (
        <div className="max-h-64 overflow-y-auto divide-y divide-navy/5 border border-navy/10 rounded-lg">
          {users.map((u) => {
            const isMember = members.includes(u.id);
            const checked = sel.has(u.id);
            return (
              <label key={u.id} className={`flex items-center justify-between gap-3 px-3 py-2 text-sm ${isMember ? "opacity-50" : "cursor-pointer hover:bg-navy/[0.03]"}`} data-testid={`share-user-${u.id}`}>
                <span><span className="text-navy/80">{u.name || u.email}</span> <span className="text-navy/40 text-xs">· {u.role}</span></span>
                {isMember ? <span className="text-xs text-emerald-600 flex items-center gap-1"><Check className="w-3.5 h-3.5" /> Miembro</span> :
                  <input type="checkbox" checked={checked} onChange={() => toggle(u.id)} className="accent-violet w-4 h-4" data-testid={`share-check-${u.id}`} />}
              </label>
            );
          })}
        </div>
      )}
      <div className="flex justify-end gap-2 pt-1">
        <button onClick={onClose} className="btn btn-ghost">Cancelar</button>
        <button onClick={save} disabled={saving} className="btn btn-primary" data-testid="module-share-submit">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} Invitar
        </button>
      </div>
    </div>
  );
}
